import apiClient from "./apiClient";

export const SettingApi =
{
    settings: async (slug) => {

        const response = await apiClient.get(`/api/Reviews/GetSettingPage?slug=${slug}`)
        return response.data;
    }

}